import { JSONObject } from '@/../types/common';

export function getAppFromSpaWrapper() {
  let application = null;
  const appContainer = document.getElementById('vacv-spa-container');
  if (appContainer) {
    application = appContainer.querySelector('#app');
  }
  return application;
}

export function getConfig() {
  const app = getAppFromSpaWrapper();
  if (app?.dataset?.vars) {
    return JSON.parse(app.dataset.vars);
  }
  return null;
}

export const config = getConfig();

export function getEnvVarFromConfig(cfg: JSONObject, name: string) {
  return cfg?.[name] ? cfg[name] : import.meta.env[name];
}

export function getEnvVar(name: string) {
  return getEnvVarFromConfig(config, name);
}
